// Fase 3 · Precarga del chunk de la carta camarero desde el plano de mesas.
// Se hace con import() programático (no con /* webpackPrefetch */ en las
// rutas) para que SOLO lo descargue quien está en el TPV: con el hint en el
// fichero de rutas, el navegador lo bajaría también en la carta QR del
// cliente. Mismas rutas de import que TpvCartaRoutes → mismo chunk.
let done = false;

export function prefetchCartaCamarero() {
  if (done) return;
  done = true;
  const run = () => {
    import("src/views/app/UserNormal/cartaCamarero/tuCartaCamarero/DarkKitchen").catch(() => {
      done = false;
    });
    import("src/views/app/UserNormal/cartaCamarero/tuCartaCamarero/DarkKitchen/TpvPayment").catch(() => {});
  };
  if (typeof window !== "undefined" && typeof window.requestIdleCallback === "function") {
    window.requestIdleCallback(run, { timeout: 4000 });
  } else {
    setTimeout(run, 1500);
  }
}
